module.exports = __webpack_public_path__ + "img/image2-web.d265377f.webp";